import { request } from "../../service/api";
import type { ApiEnvelope, MaterialListData, ProductAttributeData, ProductAttributePayload, ProductCategoryListData } from "./types";

export function fetchProductCategoryListOptions(): Promise<ApiEnvelope<ProductCategoryListData>> {
  return request("/productselector/productcategorylistoptions", { method: "GET" });
}

export function fetchProductAttributes(payload: ProductAttributePayload): Promise<ApiEnvelope<ProductAttributeData>> {
  return request("/productselector/attribute", { method: "POST", body: JSON.stringify(payload) });
}

export function fetchMaterialList(): Promise<ApiEnvelope<MaterialListData>> {
  return request("/listoptions/materiallist", { method: "GET" });
}
